exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".negative[data-v-d90e88d6]{background-color:#fff0eb;color:#ff5722;font-size:13px;line-height:18.82px;padding:12px 16px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:0 12px}.negative img[data-v-d90e88d6]{margin-top:2px;height:16px}.not-txt[data-v-d90e88d6]{-webkit-box-flex:1;-ms-flex:1;flex:1;white-space:pre-line;padding-right:8px}.select-calendar[data-v-d90e88d6]{position:absolute;top:-6px;right:36px;width:120px;border:1px solid #ffcea6}", ""]);

// exports
